import React, { useState, useEffect } from "react";
import NavDesktop from "./NavDesktop";
import NavMobile from "./NavMobile";

const NewHeader = () => {
  const [mobileView, setMobileView] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const onResize = () => {
      setMobileView(window.innerWidth <= 768);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div
      className="app-header bg-background shadow-md"
      style={{
        position: mobileView <= 768 ? "sticky" : "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: mobileView <= 768 ? 107 : 100,
      }}
    >
      {mobileView ? <NavMobile /> : <NavDesktop />}
    </div>
  );
};

export default NewHeader;
